import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';

import { ADALandmarks, ADAARIARoles } from '../../../../models/ADA';

import './SpinAgainStrip.scss';

const SpinAgainStrip = ({ darkMode, onSpinAgain, label }) => {
  const menuOpened = useSelector(state => state.data.menuOpened);

  return (
    <div className={`ccw-spin-again-strip ${darkMode ? 'dark-mode' : ''}`}>
      <div className="cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className="cpvi-grid-col w12">
            <button className={`ccw-button ${darkMode ? 'black' : 'white'}`} tabIndex={!menuOpened ? 0 : -1} onClick={onSpinAgain}>{label}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpinAgainStrip;